import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-toggle',
    imports: [CommonModule, SvgIconComponent, TranslateDirective, TranslatePipe],
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleComponent {
  @Input() toggleState?: boolean;
  @Input() isMenu = false;
  @Output() toggleEvent: EventEmitter<boolean> = new EventEmitter();

  toggle(state: boolean) {
    this.toggleEvent.emit(state)
  }
}
